const CopyRightInfo = () => {
    return (
        <div className="d-flex flex-column align-items-center">
            <p className="mb-0 d-flex justify-content-center text-center">© 2025 Lambdanest Solutions LLP. All rights reserved.</p>
            <div className="d-flex justify-content-center text-center mt-2 gap-3 flex-wrap">
                <a 
                    href="https://pathshalasanchalak.in/terms-and-conditions" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                    style={{ color: '#007bff' }}
                >
                    Terms and Conditions
                </a>
                <span className="text-muted">|</span>
                <a 
                    href="https://pathshalasanchalak.in/privacy-policy" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                    style={{ color: '#007bff' }}
                >
                    Privacy Policy
                </a>
                <span className="text-muted">|</span>
                <a 
                    href="https://pathshalasanchalak.in/contact-us" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                    style={{ color: '#007bff' }}
                >
                    Contact Us
                </a>
            </div>
        </div>
    )
}

export default CopyRightInfo